import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OperationHistoryPageContainer } from './OperationHistoryPageContainer';
import { actions } from './OperationHistoryPageContainer.actions';
import {
    getHeaderNames,
    getAccountEntries,
    getSelectOptions
} from './OperationHistoryPageContainer.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    accountEntries: getAccountEntries,
    selectOptions: getSelectOptions
});

const OperationHistoryPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routingCompat,
            loading: state.publisherAccountEntries.loading,
            totalPages: state.publisherAccountEntries.total
        };
    },
    null
)(OperationHistoryPageContainer);

export default OperationHistoryPageContainerComponent;
